module.exports = __webpack_public_path__ + "static/img/cloud.0d8638b1.png";